import http from '../http'

export const getUploadOssFileParams = params => {
  return http.request({
    url: '/basic/uploadOssFile',
    params,
    methods: 'get'
  })
}
